import { observable } from "mobx";
import { Type } from "class-transformer";
import AccountingDocumentCandidateApprovalResponse from "./accountingDocumentCandidateApprovalResponse";
import type AccountingDocumentCandidateApprovalType from "./accountingDocumentCandidateApprovalType";
import type { IApprovable } from "./types";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
class AccountingDocumentCandidateResponse implements IApprovable<AccountingDocumentCandidateApprovalType> {
  id!: string;

  @observable
  accountingTemplateId!: string;

  @observable
  sequenceName!: string;

  @observable
  @Type(() => Date)
  accountingDate!: Date;

  @observable
  accountingPeriod!: string;

  @observable
  creditSum!: number;

  @observable
  debitSum!: number;

  @observable
  documentHeaderDescription!: string;

  @observable
  chargeId?: string;

  @observable
  @Type(() => AccountingDocumentCandidateApprovalResponse)
  approvals!: AccountingDocumentCandidateApprovalResponse[];
}

export default class AccountingDocumentCandidate extends AccountingDocumentCandidateResponse {
  // This flag is set later inside VM based on currentUser role
  @observable
  isSelectable: boolean = true;
}
